/**
 *  @class
 *  @author WANG.J
 *  @function CompareTable
 */
if (!customElements.get('compare-table')) {
  class CompareTable extends HTMLElement {
    constructor() {
      super()
      const comparetable = this
      this.parent_section = comparetable.closest('.shopify-section')
      this.comparetable_tabs = Array.from(comparetable.querySelectorAll('.compare-table-tab li'))
      this.product_details = Array.from(comparetable.querySelectorAll('.tab-product-details .tab-product-detail'))
      this.product_details_fixed = Array.from(
        comparetable.querySelectorAll('.tab-product-detail-fixed .product-select')
      )
      this.comparetable_tab = comparetable.querySelector(".compare-table-tab")
      window.addEventListener('scroll', this.scroll)
      window.dispatchEvent(new Event('scroll'))
      this.comparetable_tab.addEventListener('scroll', this.tabScroll)
      this.comparetable_tab.dispatchEvent(new Event('scroll'))
    }
    tabScroll = debounce(() => {
      if(this.comparetable_tab.scrollLeft > 40){
        this.comparetable_tab.style.setProperty('--left',"40px")
      }else{
        this.comparetable_tab.style.setProperty('--left',"0px")
      }
      if(this.comparetable_tab.scrollWidth - this.comparetable_tab.offsetWidth - this.comparetable_tab.scrollLeft < 40){
        this.comparetable_tab.style.setProperty('--right',"0px")
      }else{
        this.comparetable_tab.style.setProperty('--right',"40px")
      }
    }, 50)
    scroll = debounce(() => {
      let headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10)
      let active = this.querySelector('.tab-content-item.active ')
      if (window.scrollY - active.offsetTop + headerHeight > 0) {
        active.querySelector('.fixed-content').style.display = 'block'
        document.querySelector('.header-section').style.position = 'fixed'
      } else {
        active.querySelector('.fixed-content').style.display = 'none'
        document.querySelector('.header-section').style.position = 'sticky'
      }
    }, 50)
    connectedCallback() {
      if (this.comparetable_tabs) {
        this.enableTab()
      }
      if (this.product_details) {
        this.enableSelect(this.product_details)
      }
      if (this.product_details_fixed) {
        this.enableSelect(this.product_details_fixed)
      }
    }
    enableSelect(details) {
      details.forEach((detail, index) => {
        let detailSelect = detail.querySelector('select')
        detailSelect.addEventListener('change', event => {
          const index = detailSelect.dataset.index
          const handle = detailSelect.options[detailSelect.options.selectedIndex].value
          const featuredImage = detailSelect.options[detailSelect.options.selectedIndex].dataset['featuredImage']
          const price = detailSelect.options[detailSelect.options.selectedIndex].dataset['price']
          const url = detailSelect.options[detailSelect.options.selectedIndex].dataset['url']
          const name = detailSelect.options[detailSelect.options.selectedIndex].text
          const contentItem = detailSelect.closest('.tab-content-item')
          contentItem
            .querySelectorAll('.tab-product-detail-fixed .product-select')
            [index].querySelector('select').options[detailSelect.options.selectedIndex].selected = true
          contentItem
            .querySelectorAll('.tab-product-details .tab-product-detail')
            [index].querySelector('select').options[detailSelect.options.selectedIndex].selected = true
          this.updateDetails.call(contentItem, index, handle)
          this.updateProductDetails.call(contentItem, index, handle, featuredImage, price, url, name)
          this.setDisableSelect.call(contentItem,index, handle)
        })
        detailSelect.dispatchEvent(new Event('change'))
      })
    }
    enableTab() {
      let tabs = this.comparetable_tabs
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          let handle = tab.dataset.index
          ;[].forEach.call(tabs, function (el) {
            el.classList.remove('active')
          })
          tab.classList.add('active')
          this.comparetable_tab.scrollTo({
            left: (tab.offsetLeft + tab.clientWidth / 2) - document.body.clientWidth / 2,
            behavior: "smooth"
          });
          
          if (handle) {
            this.toggleTab(handle)
          }
          event.preventDefault()
        })
      })
    }
    setDisableSelect(index,handle){
      let details = this.querySelectorAll('.tab-product-details .tab-product-detail');
      let selectedValues = []
      details.forEach((detail,i) => {
        if(window.getComputedStyle(detail).display != "none"){
          let detailSelect = detail.querySelector('select')
          selectedValues.push(detailSelect.options[detailSelect.options.selectedIndex].value)
        }
      });
      let details1 = this.querySelectorAll('.tab-product-detail-fixed .product-select')

      
      details.forEach((detail,i) => {
        let detailSelect = detail.querySelector('select')
        const selectValue = detailSelect.options[detailSelect.options.selectedIndex].value;
        let thisSelected = []
        Object.assign(thisSelected,selectedValues)
        ;[].forEach.call(detail.querySelectorAll("option[disabled=true]"), function (el) {
          el.removeAttribute("disabled")
        });
         ;[].forEach.call(thisSelected,function(item){
           if(item != selectValue){
            detail.querySelector("option[value='"+item+"']").setAttribute("disabled",true);
           }
        });
      });
      details1.forEach((detail,i) => {
        let detailSelect = detail.querySelector('select')
        const selectValue = detailSelect.options[detailSelect.options.selectedIndex].value;
        let thisSelected = []
        Object.assign(thisSelected,selectedValues)
        ;[].forEach.call(detail.querySelectorAll("option[disabled=true]"), function (el) {
          el.removeAttribute("disabled")
        });
         ;[].forEach.call(thisSelected,function(item){
           if(item != selectValue){
            detail.querySelector("option[value='"+item+"']").setAttribute("disabled",true);
           }
        });
      });
    }
    toggleTab(handle) {
      let tabs = this.querySelectorAll(`.tab-content-item:not([data-index*="${handle}"])`),
        active_tabs = this.querySelectorAll(`[data-index*="${handle}"]`)
      ;[].forEach.call(tabs, function (el) {
        el.classList.remove('active')
      })
      ;[].forEach.call(active_tabs, function (el) {
        el.classList.add('active')
      })
    }
    updateProductDetails(index, handle, featuredImage, price, url, name) {
      const productDetail = this.querySelectorAll('.tab-product-details .tab-product-detail')[index]
      productDetail.querySelector('.product-price').innerHTML = price
      productDetail.querySelector('.product-more a').href = url
      productDetail.querySelector('.product-image img').src = featuredImage
      productDetail.querySelector('.product-shop quick-view').dataset['productHandle'] = handle
      const itemProductDetail = this.querySelectorAll('.tab-item-product-detail .tab-product-detail')[index]
      itemProductDetail.querySelector('.product-name').innerText = name
      itemProductDetail.querySelector('.product-price').innerHTML = price
      itemProductDetail.querySelector('.product-more a').href = url
      itemProductDetail.querySelector('.product-image img').src = featuredImage
      itemProductDetail.querySelector('.product-shop quick-view').dataset['productHandle'] = handle
    }
    updateDetails(index, handle) {
      if(this.querySelector('#specification-' + handle)){
        let specificationStr = this.querySelector('#specification-' + handle).textContent.trim()
        if (specificationStr) {
          let specifications = JSON.parse(specificationStr)
          /** [{ title, desc }], desc 为数组 */
          let specMap = {}
          specifications.forEach(specification => {
            const specificationArr = specification.split(' -- ')
            const title = specificationArr[1]
            const desc = specificationArr[2] ? specificationArr[2] : '-'
            // let specLiHtml = `<li><div class="title">${title}</div><div class="des">${desc}</div></li>`
            const specObj = { title: title, desc: [desc] } 
            if (specificationArr[0]) {
              const key = specificationArr[0].toLowerCase()
              if (specMap[key]) {
                // specMap[specificationArr[0].toLowerCase()] = specMap[specificationArr[0].toLowerCase()] + specLiHtml
                if (specMap[key].some(v => {
                  if (v.title === title) {
                    v.desc.push(desc)
                    return true
                  }
                })) {
                  // discard
                } else {
                  specMap[key].push(specObj)
                }
              } else {
                specMap[key] = [specObj]
              }
            }
          })

          Array.from(this.querySelectorAll('[parameter-name]')).forEach(v => v.style.display = 'none')
          Object.keys(specMap).forEach(key => {
            const itemDetail = this.querySelector(`[parameter-name*="${key}"]`)
            if (itemDetail) {
              itemDetail.style.display = 'flex'
              const inner = itemDetail.querySelectorAll('.tab-item-detail-content .tab-item-detail-content-inner')[index]
              const fmtDesc = desc => {
                if (Array.isArray(desc) && desc.length > 1) {
                  return `<ul>${desc.map(v => `<li>${v}</li>`).join('')}</ul>`
                }
                return desc
              }
              inner.querySelector('.detail-inner-title').innerHTML = specMap[key].map(v => `<li><div class="title">${v.title}</div><div class="des">${fmtDesc(v.desc)}</div></li>`).join('')
            }
          })
        }
      }else{
        const itemDetails = this.querySelectorAll(`[parameter-name]`)
        itemDetails.forEach(itemDetail => {
          if (itemDetail) {
            const inner = itemDetail.querySelectorAll('.tab-item-detail-content .tab-item-detail-content-inner')[index]
            inner && inner.querySelector('.detail-inner-title') ?inner.querySelector('.detail-inner-title').innerHTML = '-':''
          }
        })
      }
    }
  }
  customElements.define('compare-table', CompareTable)
}
